import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import { Param } from '~/models/common/types'
import { onBeforeUnmount, useStore } from '@nuxtjs/composition-api'
import { ActionPayload } from 'vuex'

export default function useClassifiedSearchFacet({
  onClearAll
}: {
  onClearAll?: () => void
} = {}) {
  const { dispatch: classifiedSearchDispatch } = useNamespacedStore<
    SearchState
  >(CLASSIFIED_SEARCH_NS)
  const store = useStore()

  let unsubscribe: (() => void) | undefined

  if (onClearAll) {
    unsubscribe = store.subscribeAction((action: ActionPayload) => {
      if (action.type === `${CLASSIFIED_SEARCH_NS}/clearAll`) {
        onClearAll()
      }
    })
  }

  onBeforeUnmount(() => {
    if (unsubscribe) {
      unsubscribe()
    }
  })

  function changeParam(param: Param) {
    classifiedSearchDispatch('facetChanged', {
      params: [param]
    })
  }

  function changeParams(params: Param[]) {
    classifiedSearchDispatch('facetChanged', {
      params
    })
  }

  return { changeParam, changeParams }
}
